<template>
    <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
        <div id="fullscreen-loader" v-if="loading">
            <img src="@/assets/logo.png" />
        </div>
        <side-bar :title="$store.state.props.appName" :data-mobile-visible="mobileVisible" @close="toggleSidebar">
            <template slot="links">
                <user-menu :title="user.name"></user-menu>
                <div class="event-info">
                    <div class="d-flex justify-content-center flex-wrap">
                        <img v-if="event.logo && event.logo._id" :src="$store.state.baseUrl + event.logo.path"
                            height="90px" />
                        <div class="w-100">
                            <h2>{{ event.name }}</h2>
                            <p>From <span>{{ event.startDate | date }}</span> To <span>{{ event.endDate | date }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <sidebar-item
                    :link="{ name: 'website', icon: 'now-ui-icons design_app', path: `/evt/${$route.params.eventId}` }"
                    title="External" />
                <sidebar-item v-if="user.admin || userHasPermissions(['viewDashboard'])"
                    :link="{ name: 'dashboard', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}` }" />
                <sidebar-item v-if="user.admin || userHasPermissions(['viewUsers'])"
                    :link="{ name: 'users', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/users` }"
                    title="Users" />
                <sidebar-item v-if="user.admin || userHasPermissions(['viewRegistrants'])"
                    :link="{ name: 'attendees', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/attendees` }"
                    title="Registrants" />
                <sidebar-item v-if="user.admin || userHasPermissions(['checkinActivities'])"
                    :link="{ name: 'activities', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/activities` }"
                    title="Activities" />
                <sidebar-item v-if="user.admin || user._id"
                    :link="{ name: 'checkpoints', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/checkpoints` }"
                    title="checkpoints" />
                <sidebar-item v-if="user.admin || user._id"
                    :link="{ name: 'checkpointfields', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/checkpointfields` }"
                    title="checkpoint fields" />
                <sidebar-item v-if="user.admin || user._id"
                    :link="{ name: 'checkpointfields-data', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/checkpointfields-data` }"
                    title="checkpoint fields data" />
                <sidebar-item v-if="user.admin || userHasPermissions(['viewRegistrationTypes'])"
                    :link="{ name: 'registration-types', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/registration-types` }"
                    title="Registration Types" />
                <sidebar-item v-if="user.admin || userHasPermissions(['editRegistrationTypes'])"
                    :link="{ name: 'registration-type-groups', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/registration-type-groups` }"
                    title="Registration Type Groups" />
                <sidebar-item v-if="user.admin || userHasPermissions(['viewReports'])" title="Reports"
                    :link="{ name: 'reports', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/reports` }" />
                <sidebar-item v-if="user.admin || userHasPermissions(['downloadStandaloneReports'])"
                    title="Standalone Reports"
                    :link="{ name: 'standalone-reports', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/standalone-reports` }" />
                <sidebar-item v-if="user.admin || userHasPermissions(['viewCustomFields'])"
                    :link="{ name: 'custom-fields', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/custom-fields` }"
                    title="Custom Fields" />
                <sidebar-item v-if="user.admin"
                    :link="{ name: 'user-activity', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/user-activity` }"
                    title="Log" />
                <sidebar-item v-if="user.admin || userHasPermissions(['sendMassEmails'])"
                    :link="{ name: 'mass-emails-log', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/mass-emails-log` }"
                    title="Mass Emails Log" />
                <sidebar-item v-if="user.admin || userHasPermissions(['sendMassTexts'])"
                    :link="{ name: 'mass-text-log', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/mass-text-log` }"
                    title="Mass Text Log" />
                <sidebar-item v-if="user.admin || userHasPermissions(['accessToTemplates'])"
                    :link="{ name: 'templates', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/templates` }"
                    title="Templates" />
                <sidebar-item v-if="user.admin || userHasPermissions(['settings'])"
                    :link="{ name: 'settings', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/settings` }" />
                <sidebar-item v-if="user.admin"
                    :link="{ name: 'file-uploads', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/uploads` }"
                    title="Uploads" />
            </template>
        </side-bar>

        <div class="main-panel d-flex flex-wrap">
            <navbar :transparent="false">
                <div class="navbar-wrapper">
                    <el-button class="mr-2 d-block d-lg-none" @click="toggleSidebar()">
                        <fa icon="bars" />
                    </el-button>
                    <router-link class="navbar-brand" :to="{ name: 'events' }">
                        All Events
                    </router-link>
                </div>
            </navbar>

            <router-view name="header"></router-view>

            <div v-if="!loading" :class="{ content: !$route.meta.hideContent }" class="w-100">
                <zoom-center-transition :duration="200" mode="out-in">
                    <router-view></router-view>
                </zoom-center-transition>
            </div>

            <content-footer v-if="!$route.meta.hideFooter"></content-footer>
        </div>
    </div>
</template>

<script>
/*  eslint-disable no-new  */
import { ZoomCenterTransition } from 'vue2-transitions'
import { mapState } from 'vuex'
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import ContentFooter from '@/components/layout/ContentFooter.vue'
import UserMenu from '@/components/layout/Extra/UserMenu.vue'
import { Navbar } from '@/components/now-ui'
import moment from 'moment'
import router from '../router'
import { createPoller } from '../printService';
import $http from '../http'

function hasElement(className) {
    return document.getElementsByClassName(className).length > 0
}

function initScrollbar(className) {
    if (hasElement(className)) {
        new PerfectScrollbar(`.${className}`)
    } else {
        // try to init it later in case this component is loaded async
        setTimeout(() => {
            initScrollbar(className)
        }, 100)
    }
}

export default {
    components: {
        ContentFooter,
        UserMenu,
        ZoomCenterTransition,
        Navbar
    },
    computed: {
        ...mapState(['user', 'event'])
    },
    watch: {
        'event': function (nv) {
            if (nv.pollRegistrations || nv.pollCheckpoints) {
                let interval = nv.pollingInterval || 30000
                this.initPoller(interval);
                console.log("Poller Initialized with interval: " + interval + " Seconds");
            }
            else if(this.printPoller){
                this.printPoller.stop();
                console.log("Poller Stopped");
            }
            
        }
    },
    data() {
        return {
            mobileVisible: false,
            loading: false,
            printPoller: null
        }
    },
    async mounted() {
        let docClasses = document.body.classList
        let isWindows = navigator.platform.startsWith('Win')
        if (isWindows) {
            // if we are on windows OS we activate the perfectScrollbar function
            initScrollbar('sidebar')
            initScrollbar('sidebar-wrapper')

            docClasses.add('perfect-scrollbar-on')
        } else {
            docClasses.add('perfect-scrollbar-off')
        }

        router.beforeEach((to, from, next) => {
            if (this.mobileVisible) {
                this.toggleSidebar()
            }

            next()
        })

        await this.getData()

        // // attach background print service polling
        // if (this.event.pollRegistrations || this.event.pollCheckpoints) {
        //     this.initPoller(this.event.pollingInterval);
        // }
    },
    beforeDestroy() {
        this.printPoller.stop();
    },
    methods: {
        initPoller(interval) {
            if (this.printPoller) {
                this.printPoller.stop();
            }
            this.printPoller = createPoller(() => this.claimJob(), interval);
            this.printPoller.start();
        },

        userHasPermissions(permissions) {
            if (this.user.admin) return true;
            const roles = this.event.adminRoles && this.user._id && this.event.adminRoles[this.user._id] ? this.event.adminRoles[this.user._id] : []
            let valid = true
            permissions.forEach(per => {
                if (!roles[per]) valid = false;
            })
            return valid;
        },
        toggleSidebar: function () {
            this.mobileVisible = !this.mobileVisible
        },
        getData: async function () {
            this.loading = true
            try {
                await Promise.all([
                    this.$store.dispatch('getUser'),
                    this.$store.dispatch('get', { path: 'events', key: 'event', id: this.$route.params.eventId })
                ])
            } catch (e) {
                this.$notify({ type: 'danger', message: 'Unauthorized!' })
                this.$router.push({ name: 'login' })
            }
            this.loading = false
        },
        async claimJob() {
            if (!this.userHasPermissions(['pollRegistrationPrintJobs']) || !this.userHasPermissions(['pollCheckpointPrintJobs'])) {
                return this.event.pollingInterval;
            }

            const eventPolling =
            this.user &&
            this.user.polling &&
            this.user.polling[this.event._id];
            
            if (!eventPolling) {
                return this.event.pollingInterval;
            }

            const processJob = async (type, endpoint, printFn) => {
                const res = await $http.post(endpoint);
                if(res.data){
                    const done = await printFn(res.data);
                    const status = done ? 'printed' : 'failed';
                    if (!done) {
                        console.log("failed to print job");
                    }
                    await $http.patch(
                        `/api/print-jobs/${res.data._id}`,
                        { status }
                    );
                }
            };
            // console.log("Claiming Print Job..");
            
            if (eventPolling.registrations && this.event.pollRegistrations) {
                await processJob(
                    "Registration",
                    "/api/print-jobs/claim/reg",
                    (data) => this.printReg(data.registration)
                );
            }

            if (eventPolling.checkpoints && this.event.pollCheckpoints) {
                await processJob(
                    "Checkpoint",
                    "/api/print-jobs/claim/checkpoint",
                    (data) => this.printCheckpointCheckin(data)
                );
            }
            // Log the operations done in this poll

            return this.event.pollingInterval;
        },
        async printCheckpointCheckin(data) {
            let checkpointName = data.checkpoint.name;
            let code = data.checkpointCheckin.code;

            let confirmationNumber = data.checkpointCheckin.attendees[0].confirmationNumber;
            let labels = []
            const res = await $http.get(`/api/checkpointfields-data?eventId=${this.$route.params.eventId}&registration=${confirmationNumber}&isConfirmationNumber=true`);
            const checkpointFieldData = res.data.data;
            const printOnBadgeFields = data.checkpoint.fieldsForCheckinAndAttendeesPage.filter(f => f.printInfoOnBadge)
            data.checkpointCheckin.attendees.forEach(at => {
                let names = this.getNameFromRegistration(at).split(',')
                const regCheckpointFieldData = checkpointFieldData.find(cfd => cfd.registration == at._id)
                const regPrintOnBadgeValues = []
                printOnBadgeFields.forEach(f => {
                    let val = this.getFieldValueFromRegistration(f._id, regCheckpointFieldData)
                    if(val) regPrintOnBadgeValues.push(val)
                })
                // console.log(regPrintOnBadgeValues);
                
                labels.push(
                    `<?xml version="1.0" encoding="utf-8"?>
                        <DieCutLabel Version="8.0" Units="twips">
                            <PaperOrientation>Landscape</PaperOrientation>
                            <Id>ZipDisk</Id>
                            <IsOutlined>false</IsOutlined>
                            <PaperName>30370 Zip Disk</PaperName>
                            <DrawCommands>
                                <RoundRectangle X="0" Y="0" Width="2880" Height="3375" Rx="270" Ry="270" />
                            </DrawCommands>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${checkpointName}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="14" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="344" Y="1527" Width="1764" Height="311.999999999999" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <BarcodeObject>
                                    <Name>BARCODE</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <Text>${at._id}</Text>
                                    <Type>QRCode</Type>
                                    <Size>Large</Size>
                                    <TextPosition>None</TextPosition>
                                    <TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                    <CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                    <TextEmbedding>None</TextEmbedding>
                                    <ECLevel>0</ECLevel>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
                                </BarcodeObject>
                                <Bounds X="2163" Y="1395" Width="1095" Height="1044" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <ShapeObject Stroke="SolidLine">
                                    <Name>SHAPE</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <ShapeType>HorizontalLine</ShapeType>
                                    <LineWidth>15</LineWidth>
                                    <LineAlignment>Center</LineAlignment>
                                    <FillColor Alpha="0" Red="255" Green="255" Blue="255" />
                                </ShapeObject>
                                <Bounds X="317" Y="1350" Width="2775" Height="15" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_1</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${names[1].toUpperCase()}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="24" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="195" Width="2851" Height="497.999999999999" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_2</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${names[0].toUpperCase()}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="20" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="843.000000000001" Width="2805" Height="366" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_3</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${code}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="14" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="1983" Width="1798" Height="357" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_4</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${confirmationNumber} | ${data.checkpointCheckin.attendees.length} ${ regPrintOnBadgeValues.length ? ' | ' + regPrintOnBadgeValues.join(' | ') : '' }</String>
                                            <Attributes>
                                                <Font Family="Century Gothic" Size="12" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="2494" Width="2835" Height="165" />
                            </ObjectInfo>
                        </DieCutLabel>
                `)
            });

            labels.push(
                `<?xml version="1.0" encoding="utf-8"?>
                        <DieCutLabel Version="8.0" Units="twips">
                            <PaperOrientation>Landscape</PaperOrientation>
                            <Id>ZipDisk</Id>
                            <IsOutlined>false</IsOutlined>
                            <PaperName>30370 Zip Disk</PaperName>
                            <DrawCommands>
                                <RoundRectangle X="0" Y="0" Width="2880" Height="3375" Rx="270" Ry="270" />
                            </DrawCommands>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>CenterBlock</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${checkpointName}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="353.000000000001" Y="1593" Width="2769" Height="371.999999999999" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <ShapeObject Stroke="SolidLine">
                                    <Name>SHAPE</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <ShapeType>HorizontalLine</ShapeType>
                                    <LineWidth>15</LineWidth>
                                    <LineAlignment>Center</LineAlignment>
                                    <FillColor Alpha="0" Red="255" Green="255" Blue="255" />
                                </ShapeObject>
                                <Bounds X="317" Y="1470" Width="2880" Height="15" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_1</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${code}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="20" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="315" Width="1447" Height="467.999999999999" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_2</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">Count: ${data.checkpointCheckin.attendees.length}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="903.000000000001" Width="1398" Height="456" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_3</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">Registration: ${confirmationNumber}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="11" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="347.999999999999" Y="2025" Width="2772" Height="300" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_4</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>CenterBlock</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">Retain this label for Checkout</String>
                                            <Attributes>
                                                <Font Family="Arial" Size="10" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="2446" Width="2880" Height="270" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <BarcodeObject>
                                    <Name>BARCODE</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <Text>${data.checkpointCheckin.attendees[0]._id}</Text>
                                    <Type>QRCode</Type>
                                    <Size>Medium</Size>
                                    <TextPosition>None</TextPosition>
                                    <TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                    <CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                    <TextEmbedding>None</TextEmbedding>
                                    <ECLevel>0</ECLevel>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
                                </BarcodeObject>
                                <Bounds X="1818" Y="270.000000000001" Width="1212" Height="990" />
                            </ObjectInfo>
                        </DieCutLabel>
                `)

            let done = false;
            dymo.label.framework.trace = true;
            dymo.label.framework.init(() => {
                const printers = dymo.label.framework.getPrinters();

                if (!printers.length) {
                    console.log("no supported printers found");
                    return done;
                }
                console.log("Printers: ", printers)
                try {

                    for (let labelXml of labels) {
                        const label = dymo.label.framework.openLabelXml(labelXml);
                        label.print("DYMO LabelWriter 450");
                    }
                    done = true;
                } catch (error) {
                    console.log(error);
                }
            });

            return done;
        },
        getFieldValueFromRegistration(fieldId, registration){
            if(fieldId){
                let regFields = registration.fields;
                let field = regFields.find(el => el._id == fieldId)
                if(field && field.value != undefined) return field.value;
            }
            return null
        },
        printReg: async function (registration) {
            let confirNumActivityCode = [];
            if (
                registration.confirmationNumber &&
                this.event.includeConfirmationNumberOnBadge
            )
                confirNumActivityCode.push(registration.confirmationNumber);
            let allActivityArr = [
                ...registration.registeredActivities,
                ...registration.fieldBasedActivities
            ]
                .map(item => item.badgeCode)
                .filter(el => el);
            if (
                allActivityArr.length &&
                this.event.displayCodeOnBadgeForActivities
            )
                confirNumActivityCode.push(...allActivityArr);

            let title = registration.fields.find(
                field => field.fieldMapping === "title"
            );
            registration.type.fields.filter((field, index) => {
                if (field.fieldMapping === "title")
                    title =
                        !title &&
                            registration.fields.length ==
                            registration.type.fields.length
                            ? registration.fields[index]
                            : title;
            });
            title = title ? title.value : "";

            let firstName = registration.fields.find(
                field => field.fieldMapping === "firstName"
            );
            firstName = firstName ? firstName.value : "";
            let lastName = registration.fields.find(
                field => field.fieldMapping === "lastName"
            );
            lastName = lastName ? lastName.value : "";

            let state = registration.fields.find(
                field => field.fieldMapping === "state"
            );
            state = state ? state.value : "";
            if (state == "" && registration.parent) {
                let parentState = registration.parent.fields.find(
                    field => field.fieldMapping === "state"
                );
                let parentTypeState = registration.parent.type.fields.find(
                    field => field.fieldMapping === "state"
                );
                state =
                    parentState && parentTypeState.pullParentDataIfNotAvailable
                        ? parentState.value
                        : "";
            }
            let city = registration.fields.find(
                field => field.fieldMapping === "city"
            );
            city = city ? city.value : "";
            if (city == "" && registration.parent) {
                let parentCity = registration.parent.fields.find(
                    field => field.fieldMapping === "city"
                );
                let parentTypeCity = registration.parent.type.fields.find(
                    field => field.fieldMapping === "city"
                );
                city =
                    parentCity && parentTypeCity.pullParentDataIfNotAvailable
                        ? parentCity.value
                        : "";
            }
            //console.log(dymo)
            dymo.label.framework.trace = true;
            dymo.label.framework.init(() => {
                const printers = dymo.label.framework.getPrinters();

                if (!printers.length) {
                    console.log("no supported printers found");
                    return;
                }

                console.log("Printers: ", printers)

                const labelXml = `<?xml version="1.0" encoding="utf-8"?>
                                    <DieCutLabel Version="8.0" Units="twips">
                                        <PaperOrientation>Landscape</PaperOrientation>
                                        <Id>ZipDisk</Id>
                                        <IsOutlined>false</IsOutlined>
                                        <PaperName>30370 Zip Disk</PaperName>
                                        <DrawCommands>
                                            <RoundRectangle X="0" Y="0" Width="2880" Height="3375" Rx="270" Ry="270" />
                                        </DrawCommands>
                                        <ObjectInfo>
                                            <TextObject>
                                                <Name>TEXT</Name>
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                                <LinkedObjectName />
                                                <Rotation>Rotation0</Rotation>
                                                <IsMirrored>False</IsMirrored>
                                                <IsVariable>False</IsVariable>
                                                <GroupID>-1</GroupID>
                                                <IsOutlined>False</IsOutlined>
                                                <HorizontalAlignment>Center</HorizontalAlignment>
                                                <VerticalAlignment>Top</VerticalAlignment>
                                                <TextFitMode>ShrinkToFit</TextFitMode>
                                                <UseFullFontHeight>True</UseFullFontHeight>
                                                <Verticalized>False</Verticalized>
                                                <StyledText>
                                                    <Element>
                                                        <String xml:space="preserve">${city.toUpperCase()}</String>
                                                        <Attributes>
                                                            <Font Family="Britannic" Size="14" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                                        </Attributes>
                                                    </Element>
                                                </StyledText>
                                            </TextObject>
                                            <Bounds X="344" Y="1527" Width="1764" Height="311.999999999999" />
                                        </ObjectInfo>
                                        <ObjectInfo>
                                            <BarcodeObject>
                                                <Name>BARCODE</Name>
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                                <LinkedObjectName />
                                                <Rotation>Rotation0</Rotation>
                                                <IsMirrored>False</IsMirrored>
                                                <IsVariable>False</IsVariable>
                                                <GroupID>-1</GroupID>
                                                <IsOutlined>False</IsOutlined>
                                                <Text>${registration._id}</Text>
                                                <Type>QRCode</Type>
                                                <Size>Large</Size>
                                                <TextPosition>None</TextPosition>
                                                <TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <TextEmbedding>None</TextEmbedding>
                                                <ECLevel>0</ECLevel>
                                                <HorizontalAlignment>Center</HorizontalAlignment>
                                                <QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
                                            </BarcodeObject>
                                            <Bounds X="2163" Y="1395" Width="1095" Height="1044" />
                                        </ObjectInfo>
                                        <ObjectInfo>
                                            <ShapeObject Stroke="SolidLine">
                                                <Name>SHAPE</Name>
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                                <LinkedObjectName />
                                                <Rotation>Rotation0</Rotation>
                                                <IsMirrored>False</IsMirrored>
                                                <IsVariable>False</IsVariable>
                                                <GroupID>-1</GroupID>
                                                <IsOutlined>False</IsOutlined>
                                                <ShapeType>HorizontalLine</ShapeType>
                                                <LineWidth>15</LineWidth>
                                                <LineAlignment>Center</LineAlignment>
                                                <FillColor Alpha="0" Red="255" Green="255" Blue="255" />
                                            </ShapeObject>
                                            <Bounds X="317" Y="1350" Width="2775" Height="15" />
                                        </ObjectInfo>
                                        <ObjectInfo>
                                            <TextObject>
                                                <Name>TEXT_1</Name>
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                                <LinkedObjectName />
                                                <Rotation>Rotation0</Rotation>
                                                <IsMirrored>False</IsMirrored>
                                                <IsVariable>False</IsVariable>
                                                <GroupID>-1</GroupID>
                                                <IsOutlined>False</IsOutlined>
                                                <HorizontalAlignment>Center</HorizontalAlignment>
                                                <VerticalAlignment>Top</VerticalAlignment>
                                                <TextFitMode>ShrinkToFit</TextFitMode>
                                                <UseFullFontHeight>True</UseFullFontHeight>
                                                <Verticalized>False</Verticalized>
                                                <StyledText>
                                                    <Element>
                                                        <String xml:space="preserve">${title} ${firstName.toUpperCase()}</String>
                                                        <Attributes>
                                                            <Font Family="Britannic" Size="24" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                                        </Attributes>
                                                    </Element>
                                                </StyledText>
                                            </TextObject>
                                            <Bounds X="317" Y="195" Width="2851" Height="497.999999999999" />
                                        </ObjectInfo>
                                        <ObjectInfo>
                                            <TextObject>
                                                <Name>TEXT_2</Name>
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                                <LinkedObjectName />
                                                <Rotation>Rotation0</Rotation>
                                                <IsMirrored>False</IsMirrored>
                                                <IsVariable>False</IsVariable>
                                                <GroupID>-1</GroupID>
                                                <IsOutlined>False</IsOutlined>
                                                <HorizontalAlignment>Center</HorizontalAlignment>
                                                <VerticalAlignment>Top</VerticalAlignment>
                                                <TextFitMode>ShrinkToFit</TextFitMode>
                                                <UseFullFontHeight>True</UseFullFontHeight>
                                                <Verticalized>False</Verticalized>
                                                <StyledText>
                                                    <Element>
                                                        <String xml:space="preserve">${lastName.toUpperCase()}</String>
                                                        <Attributes>
                                                            <Font Family="Britannic" Size="20" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                                        </Attributes>
                                                    </Element>
                                                </StyledText>
                                            </TextObject>
                                            <Bounds X="317" Y="843.000000000001" Width="2805" Height="366" />
                                        </ObjectInfo>
                                        <ObjectInfo>
                                            <TextObject>
                                                <Name>TEXT_3</Name>
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                                <LinkedObjectName />
                                                <Rotation>Rotation0</Rotation>
                                                <IsMirrored>False</IsMirrored>
                                                <IsVariable>False</IsVariable>
                                                <GroupID>-1</GroupID>
                                                <IsOutlined>False</IsOutlined>
                                                <HorizontalAlignment>Center</HorizontalAlignment>
                                                <VerticalAlignment>Top</VerticalAlignment>
                                                <TextFitMode>ShrinkToFit</TextFitMode>
                                                <UseFullFontHeight>True</UseFullFontHeight>
                                                <Verticalized>False</Verticalized>
                                                <StyledText>
                                                    <Element>
                                                        <String xml:space="preserve">${state.toUpperCase()}</String>
                                                        <Attributes>
                                                            <Font Family="Britannic" Size="14" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                                        </Attributes>
                                                    </Element>
                                                </StyledText>
                                            </TextObject>
                                            <Bounds X="317" Y="1983" Width="1798" Height="357" />
                                        </ObjectInfo>
                                        <ObjectInfo>
                                            <TextObject>
                                                <Name>TEXT_4</Name>
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                                <LinkedObjectName />
                                                <Rotation>Rotation0</Rotation>
                                                <IsMirrored>False</IsMirrored>
                                                <IsVariable>False</IsVariable>
                                                <GroupID>-1</GroupID>
                                                <IsOutlined>False</IsOutlined>
                                                <HorizontalAlignment>Center</HorizontalAlignment>
                                                <VerticalAlignment>Top</VerticalAlignment>
                                                <TextFitMode>ShrinkToFit</TextFitMode>
                                                <UseFullFontHeight>True</UseFullFontHeight>
                                                <Verticalized>False</Verticalized>
                                                <StyledText>
                                                    <Element>
                                                        <String xml:space="preserve">${confirNumActivityCode.join(
                    "|"
                )}</String>
                                                        <Attributes>
                                                            <Font Family="Century Gothic" Size="12" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                                        </Attributes>
                                                    </Element>
                                                </StyledText>
                                            </TextObject>
                                            <Bounds X="317" Y="2494" Width="2835" Height="165" />
                                        </ObjectInfo>
                                    </DieCutLabel>`;
                //console.log('@@labelXml', labelXml)
                const label = dymo.label.framework.openLabelXml(labelXml);
                label.print("DYMO LabelWriter 450");
            });
        },
        getNameFromRegistration(registration) {
            let name = ''
            const firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            const lastName = registration.fields.find(field => field.fieldMapping === 'lastName')

            if (lastName) name += lastName.value + ','
            if (firstName) name += firstName.value

            return name
        },
    },
    filters: {
        date: (value) => moment(value).format('MMMM DD, YYYY')
    }
}
</script>

<style lang="scss">
$scaleSize: .95;

@keyframes zoomIn95 {
    from {
        opacity: 0;
        transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }

    to {
        opacity: 1;
    }
}

.main-panel .zoomIn {
    animation-name: zoomIn95;
}

.sidebar-wrapper {
    .event-info {
        padding: 10px;
        color: white;
        text-align: center;

        h2 {
            margin: 0;
            font-size: 20px;
        }

        p {
            font-size: 13px;
            white-space: normal !important;
            line-height: 20px !important;

            span {
                font-weight: bold;
            }
        }
    }
}

.sidebar .logo {
    button {
        position: absolute;
        top: 12px;
        right: 10px;
    }
}

@keyframes zoomOut95 {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
        transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
}

.main-panel .zoomOut {
    animation-name: zoomOut95;
}
</style>
